import React from "react";
import styled from "styled-components";

export interface IDisclaimerProps {
    disclaimer: string,
    className?: string
}

const DisclaimerContainer = styled.div`
    div {
        margin-bottom: 1rem;
    }
`;

export default (props: IDisclaimerProps) => {
    const { disclaimer, className } = props;
    return (
        <DisclaimerContainer className={`${className} p-3 mt-2 pl-5`}>
            <div className="float-left pr-2">*</div>
            {disclaimer.split(/\\n/g).map((d,index)=> <div className="pl-3" key={index}><small>{d.trim()}</small></div>)}
        </DisclaimerContainer>
    );
};
